import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-crud',
  templateUrl: './crud.component.html',
  styleUrls: ['./crud.component.scss']
})
export class CrudComponent implements OnInit {
  @Input() title = '';
  @Input() listTemplate: TemplateRef<any>
  @Input() formTemplate: TemplateRef<any>
  @Input() form: FormGroup;
  @Input() list = [];  
  @Output() save = new EventEmitter();
  @Output() remove = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
  }


  async selectItem(item) {
    this.form.patchValue(item.option.value);    
  }

  async onRemove(event, item) {
    event.preventDefault();
    event.stopPropagation();
    this.remove.emit(item)
  }

}
